import { INITIAL_STATE } from './constants';
import { actionTypes } from 'reducers/error/actionTypes';

const errorReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.BATCH_ERROR: {
            return {
                ...state,
                batchError: action.payload,
            };
        }
        case actionTypes.SET_ERROR_CONTENT: {
            return {
                ...state,
                errorContent: action.payload,
            };
        }
        case actionTypes.SET_ERROR_TYPE: {
            return {
                ...state,
                errorType: action.payload,
            };
        }
        case actionTypes.SET_ERROR_MESSAGE: {
            return {
                ...state,
                errorMessage: action.payload,
            };
        }
        case actionTypes.SET_PAGE_NAME: {
            if (!action.payload) return state;

            return {
                ...state,
                pageName: action.payload,
            };
        }
        case actionTypes.SET_ERROR: {
            const pageName = action.payload.pageName ?? state.pageName;

            return {
                ...state,
                errorContent: action.payload.errorContent,
                errorType: action.payload.errorType,
                errorMessage: action.payload.errorMessage,
                errorNumber: action.payload.errorNumber,
                pageName,
            };
        }
        default: {
            return state;
        }
    }
};

module.exports = errorReducer;
